import * as classNames from 'classnames'
import * as React from 'react'
import { IDriverSchedule } from './DriverViewSchedule'

interface IDriverViewScheduleWorkingHoursProps {
  workingHoursList: IDriverSchedule[]
}

interface IDriverViewScheduleWorkingHoursItemProps {
  item: IDriverSchedule
  key: string
}

const DriverViewScheduleWorkingHours = (props: IDriverViewScheduleWorkingHoursProps) => {
  return (
    <React.Fragment>
      {props.workingHoursList.map((value, index) => {
        return <DriverViewScheduleWorkingHoursItem key={`item-${index}`} item={value} />
      })}
    </React.Fragment>
  )
}

const DriverViewScheduleWorkingHoursItem = (props: IDriverViewScheduleWorkingHoursItemProps) => (
  <div className='mt1 p3 border-light-grey4 rounded'>
    <div className='flex flex-row'>
      <div className='col-1 h5 font-dark-grey'>From</div>
      <div className='col-1 ml3 h5 font-dark-grey'>Until</div>
      <div className='pl3 h5 font-dark-grey'>On these days</div>
    </div>
    <div className='flex flex-row items-center mt02'>
      <div className='col-1'>{props.item.from}</div>
      <div className='col-1 ml3'>{props.item.until}</div>
      <div className='pl3'>
        <ViewDaysOfWeek days={props.item.days} id={props.key} />
      </div>
    </div>
  </div>
)

const ViewDaysOfWeek = ({ days, id }: { days: string[]; id: string }) => {
  const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

  const daysOfWeekShortcut = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  return (
    <div className='flex'>
      {daysOfWeek.map((it, index) => {
        const classes = classNames('day-of-week p1 mt1', {
          'bg-light-grey2 font-grey2': !days.includes(it),
          'bg-green font-white': days.includes(it)
        })

        return (
          <div className={classes} key={`${it}-${id}`}>
            {daysOfWeekShortcut[index]}
          </div>
        )
      })}
    </div>
  )
}

export default DriverViewScheduleWorkingHours



// WEBPACK FOOTER //
// ./src/components/drivers/DriverViewScheduleWorkingHours.tsx